var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ckeditor',_vm._g({attrs:{"editor":_vm.editor,"config":_vm.config},model:{value:(_vm.computedValue),callback:function ($$v) {_vm.computedValue=$$v},expression:"computedValue"}},_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }